import { render } from "./Stepper.vue?vue&type=template&id=4e8ae7d8"
import script from "./Stepper.vue?vue&type=script&lang=ts"
export * from "./Stepper.vue?vue&type=script&lang=ts"
script.render = render

export default script